if (!customElements.get('video-play-pause')) {
  customElements.define(
    'video-play-pause',
    class VideoPlayPause extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.init();
      }

      init() {
        this.initVideoControls();
        this.playPase()
      }
      playPase(){
        const buttons = this.querySelectorAll('.video-play-pause-button');
        buttons.forEach((button)=>{
          button.addEventListener('click', ()=>{
            const videoBlock = button.closest('.block-video-item');
            const currentVideo = videoBlock.querySelector('video, iframe');
            const videoElement = videoBlock.querySelector('video-element');
            if(!videoElement.playing){
                if (currentVideo.tagName === 'VIDEO') {
                  videoElement.setAttribute('loaded', 'true');
                  videoElement.setAttribute('playing', 'true');
                  currentVideo.muted = false;
                  currentVideo.play();
                }

                if (currentVideo.tagName === 'IFRAME') {
                  videoElement.setAttribute('loaded', 'true');
                  videoElement.setAttribute('playing', 'true');
                  if (!this.originalSrc) {
                    this.originalSrc = currentVideo.src;
                  }

                  if (!currentVideo.src.includes('autoplay')) {
                    currentVideo.src =
                      this.originalSrc +
                      (this.originalSrc.includes('?') ? '&' : '?') +
                      'autoplay=1';
                  }
                }
              }else{
                videoElement.removeAttribute('playing');

                if (currentVideo.tagName === 'VIDEO') {
                  currentVideo.pause();
                  currentVideo.currentTime = 0;
                }

                if (currentVideo.tagName === 'IFRAME') {
                  currentVideo.src = video.originalSrc; // make sure this exists per element
                }
            }
          })
        })
      }
       initVideoControls(){
        document.addEventListener('video-played', (e) => {
          const videoId = e.detail.videoId;
          const videos = this.querySelectorAll('video-element');

          videos.forEach((video) => {
            const currentVideoId = video.dataset.videoId;

            if (currentVideoId !== videoId) {
              const currentVideo = video.querySelector('video, iframe');

              if (video.playing && currentVideo) {
                video.removeAttribute('loaded');
                video.removeAttribute('playing');

                if (currentVideo.tagName === 'VIDEO') {
                  currentVideo.pause();
                  currentVideo.currentTime = 0;
                }

                if (currentVideo.tagName === 'IFRAME') {
                  currentVideo.src = video.originalSrc; // make sure this exists per element
                }
              }else{
                video.removeAttribute('loaded');
                video.removeAttribute('playing');
              }
            }
          });
        });

       }
    }
  );
}

